"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import type { Movie } from "@/types/movies";
import Modal from "@/components/portal/Modal";
import MovieHeroSection from "./MovieHeroSection";
import MovieMobileMeta from "./MovieMobileMeta";
import MovieBelowFold from "./MovieBelowFold";
import { useMovieDerived } from "./useMovieDerived";
import { useContentAccess } from "../_shared/useContentAccess";
import { useUserStore } from "@/stores/useAuthStore";
const TicketModal = dynamic(() => import("./TicketModal"), {
  ssr: false
});
interface Props {
  id: string;
  serverData: Movie;
}
export default function MoviePage(t0) {
  const $ = _c(54);
  const {
    serverData
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    isLoggedIn
  } = useUserStore();
  const router = useRouter();
  let t1;
  if ($[0] !== serverData) {
    t1 = serverData ?? {} as Movie;
    $[0] = serverData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const movie = t1;
  console.log("movie", movie);
  const {
    year,
    countries,
    genres,
    subtitles,
    images,
    persons,
    cast,
    directorName,
    durationLabel
  } = useMovieDerived(movie);
  const {
    userProfile,
    hasActiveSubscription,
    hasActiveTicket
  } = useContentAccess(movie?.uuid);
  let t2;
  if ($[2] !== isLoggedIn || $[3] !== router) {
    t2 = () => isLoggedIn ? setIsModalOpen(true) : router.push("/login");
    $[2] = isLoggedIn;
    $[3] = router;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== countries || $[6] !== durationLabel || $[7] !== genres || $[8] !== hasActiveSubscription || $[9] !== hasActiveTicket || $[10] !== images || $[11] !== movie || $[12] !== persons || $[13] !== subtitles || $[14] !== t2 || $[15] !== year) {
    t3 = <MovieHeroSection movie={movie} images={images} year={year} countries={countries} genres={genres} subtitles={subtitles} persons={persons} durationLabel={durationLabel} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} onBuyClick={t2} />;
    $[5] = countries;
    $[6] = durationLabel;
    $[7] = genres;
    $[8] = hasActiveSubscription;
    $[9] = hasActiveTicket;
    $[10] = images;
    $[11] = movie;
    $[12] = persons;
    $[13] = subtitles;
    $[14] = t2;
    $[15] = year;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== isLoggedIn || $[18] !== router) {
    t4 = () => isLoggedIn ? setIsModalOpen(true) : router.push("/login");
    $[17] = isLoggedIn;
    $[18] = router;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== countries || $[21] !== durationLabel || $[22] !== genres || $[23] !== hasActiveSubscription || $[24] !== hasActiveTicket || $[25] !== images || $[26] !== movie || $[27] !== subtitles || $[28] !== t4 || $[29] !== year) {
    t5 = <MovieMobileMeta movie={movie} images={images} year={year} countries={countries} genres={genres} subtitles={subtitles} durationLabel={durationLabel} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} onBuyClick={t4} />;
    $[20] = countries;
    $[21] = durationLabel;
    $[22] = genres;
    $[23] = hasActiveSubscription;
    $[24] = hasActiveTicket;
    $[25] = images;
    $[26] = movie;
    $[27] = subtitles;
    $[28] = t4;
    $[29] = year;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  const t6 = movie?.uuid ?? "";
  const t7 = movie?.title_fa || "";
  const t8 = movie?.summary || "";
  const t9 = userProfile?.uuid || "";
  let t10;
  if ($[31] !== cast || $[32] !== t6 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t10 = <MovieBelowFold movieUuid={t6} title={t7} summary={t8} cast={cast} profileUuid={t9} />;
    $[31] = cast;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t5) {
    t11 = <div className="mx-auto container max-w-3xl px-4 sm:px-6 lg:px-12 pb-12 z-10 lg:-translate-y-5 xl:-translate-y-10 2xl:-translate-y-21.25">{t5}{t10}</div>;
    $[37] = t10;
    $[38] = t5;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setIsModalOpen(false);
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setIsModalOpen(false);
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  const t14 = movie?.ticket?.uuid ?? "";
  const t15 = movie?.title_fa ?? "";
  const t16 = images.desktop || images.tablet || images.mobile || "";
  let t17;
  if ($[42] !== directorName || $[43] !== t14 || $[44] !== t15 || $[45] !== t16) {
    t17 = <TicketModal onClose={t13} movieUuid={t14} movieTitle={t15} moviePoster={t16} movieDirector={directorName} />;
    $[42] = directorName;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== isModalOpen || $[48] !== t17) {
    t18 = <Modal open={isModalOpen} onClose={t12}>{t17}</Modal>;
    $[47] = isModalOpen;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t11 || $[51] !== t18 || $[52] !== t3) {
    t19 = <div className="w-full flex flex-col MovieBoxe">{t3}{t11}{t18}</div>;
    $[50] = t11;
    $[51] = t18;
    $[52] = t3;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  return t19;
}